import React from 'react'
import type { Image } from 'api/api.types'

export type RawPictureProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  desktopImage: Image | null,
  mobileImage: Image | null,
  /** Low resolution mobile image; the full one is then served as 2x */
  mobileLow?: Image | null,
  lazy?: boolean,
}

/** A picture with separate sources for phones (≤480px) and larger screens */
export const RawPicture: React.FC<RawPictureProps> = (props) => {
  const { mobileImage, mobileLow, desktopImage, className, lazy, alt, ...rest } = props
  const fallback = (mobileLow ?? mobileImage ?? desktopImage) as Image
  return (
    <picture>
      {mobileImage && (
        <source
          media={'(max-width:480px)'}
          srcSet={mobileLow
            ? `${encodeURI(mobileLow.path)}, ${encodeURI(mobileImage.path)} 2x`
            : encodeURI(mobileImage.path)}
        />
      )}
      {desktopImage && (
        <source media={'(min-width:481px)'} srcSet={encodeURI(desktopImage.path)} />
      )}
      <img
        loading={lazy ? 'lazy' : undefined}
        alt={alt || fallback.name}
        title={alt || fallback.name}
        src={encodeURI(fallback.path)}
        {...rest}
        className={className}
      />
    </picture>
  )
}
